/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren } from "react";
import { CSVLink } from "react-csv";
import styled from "@emotion/styled";

interface DownloadCSVButtonProps {
  data: Array<object>;
  filename: string;
  isTradeHistoryReturned: boolean;
}

const DownloadCSVButton = ({
  data,
  filename,
  children,
  isTradeHistoryReturned,
}: PropsWithChildren<DownloadCSVButtonProps>) => {
  if (!isTradeHistoryReturned) {
    return null;
  }

  return (
    <DownloadCSVButtonWrapper>
      <CSVLink data={data} filename={filename}>
        {children}
      </CSVLink>
    </DownloadCSVButtonWrapper>
  );
};

export default DownloadCSVButton;

export const DownloadCSVButtonWrapper = styled.button`
  background: none;
  border-radius: 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  color: ${props => props.theme.button.tertiary.text.default};
  margin-left: auto;
  cursor: pointer;
`;
